/* eslint-disable array-callback-return */
import React from 'react';
import CardD from '../Cards/CardD';
import CardD1 from '../Cards/CardD1';
import "./SectionStyles/Sections.css"

const SectionD = (props) => {
  const CardTheme = [
    {
      value: 1,

    }
  ];
  const cardData = [
    {
      name: 'Super Charged Twister',
      price: '250',
      img: 'https://www.kaybees.com.pk/_next/image?url=https%3A%2F%2Fassets.indolj.io%2Fimages%2F1683198516-tb1.jpg&w=384&q=75',
      des: '1 Regular Pizza  + 2 Pcs Cheese Garlic Bread + 2 Drink 345ML',
      id: 1234,
    },
    {
      name: 'CardD 2',
      price: '150',
      img: 'https://www.kaybees.com.pk/_next/image?url=https%3A%2F%2Fassets.indolj.io%2Fimages%2F1683198516-tb1.jpg&w=384&q=75',
      des: 'Description of CardD 2',
      id: 2345,
    },
    {
      name: 'CardD 3',
      price: '200',
      img: 'https://www.kaybees.com.pk/_next/image?url=https%3A%2F%2Fassets.indolj.io%2Fimages%2F1683198516-tb1.jpg&w=384&q=75',
      des: 'Description of CardD 3',
      id: 3456,
    },
  ];

  return (
    <>
      {CardTheme.map((theme) => {

        if (theme.value === 1) {
          return (
    <div id={props.id} key={theme.value} className='main-main'>
      <h1> {props.Heading}</h1>
      <div className='main'>
        {cardData.map((data,id) => (
          <CardD
            key={id}
            id={data.id}
            name={data.name}
            price={data.price}
            img={data.img}
            des={data.des}
          />
        ))}
      </div>
      </div>
        )
      }
      else if (theme.value === 2) {
        return (
          <div id={props.id} key={theme.value} className='main-main'>
            <h1>{props.Heading}</h1>
            <div className='main'>
              {cardData.map((data, id) => (
                   <CardD1
                   key={id}
                   id={data.id}
                   name={data.name}
                   price={data.price}
                   img={data.img}
                   des={data.des}
                 />
              ))}
            </div>
          </div>
      )
    }
  }
  )
  }
</>
  );
};
SectionD.defaultProps={
  Heading:"Section D",
  id:'sectionD'
}

export default SectionD;
